import { render } from "./TunjanganJabatanForm.vue?vue&type=template&id=192ad00e"
import script from "./TunjanganJabatanForm.vue?vue&type=script&lang=js"
export * from "./TunjanganJabatanForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__